import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: storeStructure.VoDOptimizationSettings,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have optimization settings, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'geometry',
      label: 'Geometry',
      type: FormInputTypes.SELECT,
      canEdit: true,
      canCreate: true,
      helpText: 'Geometry transformations to apply.',
      width: '10rem',
      options: [
        { name: '', value: '' },
        { name: 'equirectangular', value: 'globe' },
        { name: 'ap3', value: 'ap3' },
        { name: 'cubemap 32', value: 'cubemap_32' },
        { name: 'hemi-sphere', value: 'square-1_180' },
        { name: 'flat', value: 'flat' },
        { name: 'control room', value: 'croom' },
        { name: 'control room v2', value: 'croomv2' },
      ],
    },
    {
      attributeName: 'opBitrates',
      label: 'Bitrate',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: ' Video bitrates to use in output (kbps).',
      pattern: /^[0-9\b]+$/,
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'faceDimension',
      label: 'Face Dimension',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'For renditions using the cubemap transformations, the face dimension size to be applied in each profile (pixels).',
      pattern: /^(5\d{2}|[6-9]\d{2}|1[0-1]\d{2}|1280)$/,
      default: '1024',
      canEdit: true,
      canCreate: true,
    },

    {
      attributeName: 'opOffcenterZ',
      label: 'Off Center',
      type: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'For renditions using the transform filter, the offcenter to be applited in the x axis (values between 0.5 and -0.5).',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'opStereoModeOut',
      label: 'Stereo Mode Out',
      type: FormInputTypes.SELECT,
      default: '',
      helpText: 'The stereo mode of each rendition.',
      canEdit: true,
      canCreate: true,
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Top Bottom', value: 'tb' },
        { name: 'Left Right', value: 'lr' },
      ],
    },
    {
      attributeName: 'renditionRes',
      label: 'Rendition Res',
      type: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'The desired output resolution in each rendition leave empty, or use 0 in that list element if no resizing is desired (e.g. input resolution is to be preserved, or the output from transform filter is ok to use) use FFMpeg\'s format for resolution when using this parameter (e.g. "1920:1080,1280:720" for two resolutions, one 1080p and another one 720p), negative values are not supported.',
      default: '',
      canEdit: true,
      canCreate: true,
    },
  ],
};
